import React, { useState } from "react";

import Link from "next/link";
import AuthKit from "../data/AuthKit";
import EventKit from "../data/EventKit";
import PageKit from "../data/PageKit";

export default function LoginForm() {
  const [email, setEmail] = useState("info@willandskill.se");
  const [password, setPassword] = useState("Stadsgarden1010");
  const [eventList, setEventList] = useState({});

  const authKit = new AuthKit();
  const eventKit = new EventKit();
  const pageKit = new PageKit();

  function authenticate() {
    authKit
      .auth({ email, password })
      .then((res) => {
        authKit.setToken(res);
      })
      .then(() => {
        fetchEventList();
      });
  }

  function handleOnSubmit(e) {
    e.preventDefault();
    authenticate();
  }

  function fetchEventList() {
    eventKit.getEventList().then((data) => {
      setEventList(data);
    });
  }

  return (
    <div>
      <form onSubmit={handleOnSubmit}>
        <div>
          <input
            onChange={(e) => setEmail(e.target.value)}
            name="email"
            placeholder="Email"
            value={email}
          />
        </div>

        <div>
          <input
            onChange={(e) => setPassword(e.target.value)}
            name="password"
            placeholder="Password"
            value={password}
          />
        </div>
        <button type="submit">Login!</button>
      </form>
      <ul>
        {eventList.results &&
          eventList.results.map((event, index) => {
            return (
              <li key={event.id}>
                <Link href={`/[event]`} as={`/${event.slug}`}>
                  <a>{event.title}</a>
                </Link>
              </li>
            );
          })}
      </ul>
    </div>
  );
}
